import cx from 'classnames';
import Loader from 'components/loader';
import WhiteBox from 'components/elems/whitebox';
import {
  SportsStrings, formatMetaById, PoolStateToStatus, Status,
} from 'utils/game';
import {
  StatusElem, Actions, BetResult,
} from 'components/bets/calendar/fields';

import styles from './table.module.css';

function predictions(lines, eventId) {
  return lines.map((l) => JSON.parse(l)[eventId] || 0);
}

const Table = ({ loading, list = [] }) => {
  const firstLoading = list.length === 0 && loading;

  return (
    <WhiteBox className={cx(styles.container, 'pb-4')}>
      <table className="overflow-hidden w-full">
        <thead>
          <tr className="whitespace-no-wrap">
            <th className="text-center font-normal text-sm py-2 px-2">Start at</th>
            <th className="text-center font-normal text-sm py-2 px-2">Sport</th>
            <th className="text-center font-normal text-sm py-2 px-2">Pool Name</th>
            <th className="text-center font-normal text-sm py-2 px-2">Pool manager</th>
            <th className="text-center font-normal text-sm py-2 px-2">Format</th>
            <th className="text-center font-normal text-sm py-2 px-2">Line price</th>
            <th className="text-center font-normal text-sm py-2 px-2">Place</th>
            <th className="text-center font-normal text-sm py-2 px-2">Actions</th>
          </tr>
        </thead>
        <tbody className={styles.body}>
          {list.map(({
            ticket, bet, details,
            startTime, state, owner,
          }) => {
            const status = Status[PoolStateToStatus[state]];
            const ticketEvents = ticket?.events || [];
            const fixedEventIds = ticket?.fixedEventIds || [];
            const needToAdd = ticketEvents.filter((event) => {
              const scoresLines = predictions(bet.lines, event.id);
              return scoresLines.every((it) => it === 0) && !!event?.probability;
            }).length > 0;

            return (
              <tr key={bet.id}>
                <td className="text-sm py-2 px-3 whitespace-no-wrap">
                  <StatusElem status={status} startTime={startTime} />
                </td>
                <td className="text-center py-2 px-2 whitespace-no-wrap">
                  { SportsStrings.Football }
                </td>
                <td className="text-center py-2 px-2 whitespace-no-wrap">
                  { ticket.name }
                </td>
                <td className="text-center py-2 px-2 whitespace-no-wrap">
                  { owner || 'System' }
                </td>
                <td className="text-center py-2 px-2 whitespace-no-wrap">
                  { formatMetaById(bet.format)?.multiplier || '' }
                </td>
                <td className="text-center py-2 px-2 whitespace-no-wrap">
                  { `${bet.amount / 100}` }
                  &#x1F4B0;
                </td>
                <td className="text-center py-2 px-2">
                  <BetResult status={status} score={details} />
                </td>
                <td className="text-center py-2 px-2">
                  <Actions
                    isPoolPage
                    needToAdd={needToAdd}
                    ticketName={ticket.name}
                    fixedEventIds={fixedEventIds}
                    events={ticketEvents}
                    isPrivate={Boolean(owner)}
                    id={bet.id}
                    status={state}
                  />
                </td>
              </tr>
            );
          })}
          {(firstLoading || list.length === 0) && (
          <tr>
            <td colSpan="8" className="text-center pt-4 pb-4 px-3">
              {firstLoading ? <Loader className={styles.loader} /> : 'No pools yet'}
            </td>
          </tr>
          )}
        </tbody>
      </table>
    </WhiteBox>
  );
};

export default Table;
